import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TemperatureDashboard from './TemperatureDashboard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TemperatureDashboard />
  </React.StrictMode>
);
